<div id="chart" class="w-full">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [labels]="chartOptions.labels"
    [responsive]="chartOptions.responsive"
    [fill]="chartOptions.fill"
    [title]="chartOptions.title"
  ></apx-chart>
</div>
